module.exports = __webpack_public_path__ + "media/WeChat_20211012163929.51e6c79a.mp4";